export enum VideoType {
  PRODUCT_LONG = 'plv',
  PRODUCT_SHORT = 'psv',
  LINK_CONTENT = 'lcv',
  TEXT_CONTENT = 'tcv',
}

export const getVideoTypeLabels = (t: any) => ({
  [VideoType.PRODUCT_LONG]: t('videoTypes.labels.productLong'),
  [VideoType.PRODUCT_SHORT]: t('videoTypes.labels.productShort'),
  [VideoType.LINK_CONTENT]: t('videoTypes.labels.linkContent'),
  [VideoType.TEXT_CONTENT]: t('videoTypes.labels.textContent'),
})

export const getVideoTypeDescriptions = (t: any) => ({
  [VideoType.PRODUCT_LONG]: t('videoTypes.descriptions.productLong'),
  [VideoType.PRODUCT_SHORT]: t('videoTypes.descriptions.productShort'),
  [VideoType.LINK_CONTENT]: t('videoTypes.descriptions.linkContent'),
  [VideoType.TEXT_CONTENT]: t('videoTypes.descriptions.textContent'),
})

export const VIDEO_TYPE_API_MAP = {
  [VideoType.PRODUCT_SHORT]: 'product',
  [VideoType.LINK_CONTENT]: 'contents',
} as const

// 유틸리티 함수들
export const getVideoTypeLabel = (type: VideoType, t: any): string => {
  const labels = getVideoTypeLabels(t)
  return labels[type] || ''
}

export const getVideoTypeDescription = (type: VideoType, t: any): string => {
  const descriptions = getVideoTypeDescriptions(t)
  return descriptions[type] || ''
}

export const getApiTypeByVideoType = (type: VideoType): string => {
  if (type === VideoType.PRODUCT_SHORT) return VIDEO_TYPE_API_MAP[type]
  if (type === VideoType.LINK_CONTENT) return VIDEO_TYPE_API_MAP[type]
  return VideoType.PRODUCT_SHORT
}

export const getVideoTypeFromParam = (param: string | null): VideoType => {
  switch (param) {
    case 'plv':
      return VideoType.PRODUCT_LONG
    case 'psv':
      return VideoType.PRODUCT_SHORT
    case 'lcv':
      return VideoType.LINK_CONTENT
    case 'tcv':
      return VideoType.TEXT_CONTENT
    default:
      return VideoType.PRODUCT_LONG
  }
}

// 비디오 타입별 가이드 정보
export interface GuideItem {
  type: 'link' | 'text'
  text: string
  href?: string
}

export const getVideoTypeGuides = (type: VideoType, t: any): GuideItem[] => {
  const guideMap = {
    [VideoType.PRODUCT_LONG]: [
      {
        type: 'link' as const,
        href: 'https://blog.fastseller.shop/youtubeuploadguide/',
        text: t('videoTypes.guides.productLong.uploadGuide'),
      },
      {
        type: 'text' as const,
        text: t('videoTypes.guides.productLong.downloadPeriod'),
      },
      {
        type: 'text' as const,
        text: t('videoTypes.guides.productLong.youtubeAuth'),
      },
      {
        type: 'text' as const,
        text: t('videoTypes.guides.productLong.countingRule'),
      },
      { type: 'text' as const, text: t('videoTypes.guides.productLong.generationTime') },
      {
        type: 'text' as const,
        text: t('videoTypes.guides.productLong.uploadSchedule'),
      },
      {
        type: 'text' as const,
        text: t('videoTypes.guides.productLong.scheduleNotice'),
      },
    ],
    [VideoType.PRODUCT_SHORT]: [
      {
        type: 'link' as const,
        href: 'https://blog.fastseller.shop/youtubeuploadguide/',
        text: t('videoTypes.guides.productShort.uploadGuide'),
      },
      {
        type: 'text' as const,
        text: t('videoTypes.guides.productShort.downloadPeriod'),
      },
      { type: 'text' as const, text: t('videoTypes.guides.productShort.generationTime') },
      {
        type: 'text' as const,
        text: t('videoTypes.guides.productShort.scheduleNotice'),
      },
    ],
    [VideoType.LINK_CONTENT]: [
      {
        type: 'link' as const,
        href: 'https://blog.fastseller.shop/youtubeshortsupload/',
        text: t('videoTypes.guides.linkContent.uploadGuide'),
      },
      {
        type: 'text' as const,
        text: t('videoTypes.guides.linkContent.downloadPeriod'),
      },
      { type: 'text' as const, text: t('videoTypes.guides.linkContent.generationTime') },
      {
        type: 'text' as const,
        text: t('videoTypes.guides.linkContent.scheduleNotice'),
      },
    ],
    [VideoType.TEXT_CONTENT]: [
      {
        type: 'link' as const,
        href: 'https://blog.fastseller.shop/youtubeshortsupload/',
        text: t('videoTypes.guides.textContent.uploadGuide'),
      },
      {
        type: 'text' as const,
        text: t('videoTypes.guides.textContent.downloadPeriod'),
      },
      { type: 'text' as const, text: t('videoTypes.guides.textContent.generationTime') },
      {
        type: 'text' as const,
        text: t('videoTypes.guides.textContent.scheduleNotice'),
      },
    ],
  }
  return guideMap[type] || []
}


export enum CreateVideoType {
  PRODUCT_LONG = 'long',
  PRODUCT_SHORT = 'short',
}

export enum MaxSelectCnt {
  PRODUCT_LONG = 3,
  PRODUCT_SHORT = 1,
}
